export default "__VITE_ASSET__6ae5837b__"